import { Typography } from "@mui/material";
import { useMemo } from "react";
import type { WorkbookRun } from "../../../../api/types/workbookRuns.types";
import { formatDuration, useDurationTimer } from "../hooks/useDurationTimer";
import { getFinishTime } from "./workbookRunUtils";

interface DurationTimerProps {
  workbookRun: WorkbookRun;
  showSeconds?: boolean;
}

const WorkbookRunDuration = ({ workbookRun, showSeconds = true }: DurationTimerProps) => {
  const liveDuration = useDurationTimer({
    startTime: workbookRun.startedAt,
    isActive: workbookRun.status === "InProgress",
    showSeconds,
  });

  const staticDuration = useMemo(() => {
    const finish = getFinishTime(workbookRun);
    if (!finish || !workbookRun.startedAt) {
      return "-";
    }
    const startMs = new Date(workbookRun.startedAt).getTime();
    const endMs = new Date(finish).getTime();
    return formatDuration(endMs - startMs, showSeconds);
  }, [workbookRun, showSeconds]);

  return <Typography>{workbookRun.status === "InProgress" ? liveDuration : staticDuration}</Typography>;
};

export default WorkbookRunDuration;
